<template>
  <div class="summary-page">
    <el-main class="summary-main">
      <div class="search-wrapper">
        <el-form :inline="true" :model="filterForm" size="mini">
          <el-form-item label="店铺">
            <el-select v-model="filterForm.storeIds" multiple collapse-tags clearable placeholder="请选择">
              <el-option
                v-for="item in storeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对比类型">
            <el-select v-model="filterForm.compareType" placeholder="请选择" @change="handleSearch">
              <el-option label="全部" value="ALL"></el-option>
              <el-option label="同比" value="YOY"></el-option>
              <el-option label="环比" value="MOM"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="button-wrapper">
          <el-button type="primary" size="mini" @click="exportSummary">导出</el-button>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>

      <pre-sale-summary-table
        :rows="tableData"
        :summary="summary"
        :compare-type="filterForm.compareType"
        row-label="店铺"
        row-label-prop="storeName"
        :table-height="tableHeight"
        :loading="loading"
      ></pre-sale-summary-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="pagination.pageSizes"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </el-main>
  </div>
</template>

<script>
import PreSaleSummaryTable from '../summary/summaryTable'

export default {
  name: 'ShopSummary',
  components: { PreSaleSummaryTable },
  props: ['form'],
  data() {
    return {
      filterForm: {
        storeIds: [],
        compareType: 'ALL'
      },
      storeOptions: [],
      tableData: [],
      summary: {},
      loading: false,
      tableHeight: 0,
      pagination: {
        pageSizes: [30, 60, 90, 500],
        pageNum: 1,
        pageSize: 30,
        total: 0
      }
    }
  },
  watch: {
    'form.planTime': {
      handler() {
        this.pagination.pageNum = 1
        this.init()
      },
      immediate: true
    }
  },
  created() {
    this.getStoreOptions()
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    setTableHeight() {
      this.tableHeight = document.documentElement.clientHeight - 325
    },
    async getStoreOptions() {
      const res = await this.$q.preSalePlan.planGetShop()
      if (res.success && res.data) {
        this.storeOptions = Object.keys(res.data).map(id => ({
          id,
          name: res.data[id]
        }))
      }
    },
    getRequestData(exportTag = false) {
      return {
        exportTag,
        pageNum: exportTag ? 1 : this.pagination.pageNum,
        pageSize: exportTag ? 99999 : this.pagination.pageSize,
        filterData: {
          categoryNames: [],
          compareType: this.filterForm.compareType,
          planTime: this.form.planTime,
          storeIds: this.filterForm.storeIds
        }
      }
    },
    async init() {
      if (!this.form || !this.form.planTime) {
        return
      }
      this.setTableHeight()
      this.loading = true
      try {
        const res = await this.$q.preSalePlan.preSaleShopSummaryListPage({
          data: this.getRequestData()
        })
        if (res && res.success && res.data) {
          this.tableData = res.data.records || []
          this.summary = res.data.summary || {}
          this.pagination.total = res.data.total || 0
        } else {
          this.tableData = []
          this.summary = {}
          this.pagination.total = 0
        }
      } catch (error) {
        this.tableData = []
        this.summary = {}
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.init()
    },
    handleReset() {
      this.filterForm = {
        storeIds: [],
        compareType: 'ALL'
      }
      this.handleSearch()
    },
    handleRefresh() {
      this.pagination.pageNum = 1
      this.filterForm = {
        storeIds: [],
        compareType: 'ALL'
      }
      this.init()
      this.getStoreOptions()
    },
    handleSizeChange(value) {
      this.pagination.pageSize = value
      this.pagination.pageNum = 1
      this.init()
    },
    handleCurrentChange(value) {
      this.pagination.pageNum = value
      this.init()
    },
    async exportSummary() {
      try {
        const res = await this.$q.preSalePlan.preSaleShopSummaryListPage({
          data: this.getRequestData(true)
        })
        if (!res || !res.success || !res.data) {
          this.$message.error(res && res.message ? res.message : '导出失败')
          return
        }
      } catch (error) {
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.summary-page
  background #ffffff

.summary-main
  padding 15px 20px 10px

.search-wrapper
  display flex
  justify-content space-between
  align-items flex-start
  margin-bottom 12px

.button-wrapper
  flex-shrink 0

.pagination
  margin-top 10px
  text-align right

>>> .el-form-item
  margin-bottom 0

>>> .el-input, >>> .el-select
  width 140px
</style>
